import React from 'react'
import { reportClientLog } from '../lib/api'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary', err, info)
    try {
      const route = (typeof window !== 'undefined' && window.location) ? window.location.pathname : ''
      const url = (typeof window !== 'undefined' && window.location) ? window.location.href : ''
      const ua = (typeof navigator !== 'undefined') ? navigator.userAgent : ''
      const stack = [err?.stack, info?.componentStack].filter(Boolean).join(' | ')
      reportClientLog({
        level: 'error',
        source: 'ErrorBoundary',
        route,
        url,
        message: err?.message || String(err),
        stack,
        userAgent: ua,
      })
    } catch (_) { }
  }
  render() {
    if (this.state.hasError) {
      return <div className="p-6 text-sm text-red-700 border border-red-300 rounded">문제가 발생했습니다. 새로고침 해주세요.</div>
    }
    return this.props.children
  }
}


